import { JSX } from 'react';

import { useNav } from 'Components/Context/NavContext';
import { RequiresAttentionMarker } from 'Components/RequiresAttentionMarker/RequiresAttentionMarker';

import styles from './FixedFooter.module.css';

export interface FixedFooterProps {
    /** Save or submit button(s). Rendered to the far right of the footer. */
    buttons: JSX.Element;
    /** Rendered to the left of `buttons`. */
    content: JSX.Element;
    /** If true, a warning will be displayed next to the `buttons` (unless `errorMessage` is defined, which takes priority). */
    hasUnsavedChanges: boolean;
    /** If defined, will be displayed next to the `buttons`. */
    errorMessage?: string;
}

/** Renders a footer that remains at the bottom of the window no matter where the user scrolls on a page. */
export const FixedFooter = (props: FixedFooterProps) => {
    const { isOpen: navIsOpen } = useNav();

    return (
        <div className={`${styles.fixedFooter} ${navIsOpen ? styles.footerWithNavOpen : ''}`}>
            <div className={styles.footerContent}>
                <div className={styles.footerInfo}>{props.content}</div>
                <div className={styles.footerActions}>
                    {props.buttons && <div className={styles.saveButtons}>{props.buttons}</div>}
                    {props.errorMessage && (
                        <RequiresAttentionMarker type="negative" size="lg">
                            {props.errorMessage}
                        </RequiresAttentionMarker>
                    )}
                    {props.hasUnsavedChanges && props.errorMessage === undefined && (
                        <RequiresAttentionMarker type="negative" size="lg">
                            Your changes have not been saved.
                        </RequiresAttentionMarker>
                    )}
                </div>
            </div>
        </div>
    );
};
